import { Config } from '../../modules/Config';
import { createSigningPageUrl } from './createSigningPageUrl';
import { SigningButtonType } from './common';

import s from './SigningSection.scss';

type SigningButtonConfig = {
  dataHook: string;
  classNames: string[];
  translationKey: string;
  biName: string;
  href: string;
};
type CreateButtonConfigParams = {
  globalConfig: Config;
  type: SigningButtonType;
  isMobile?: boolean;
};

export const createButtonConfig = ({ globalConfig, type, isMobile }: CreateButtonConfigParams): SigningButtonConfig => {
  if (type === SigningButtonType.SignIn) {
    return {
      biName: 'sign_in',
      translationKey: 'menu_sign_in',
      classNames: [s.primaryButton, s.signInButton],
      // DO NOT CHANGE: this specific data-hook value is used on https://support.wix.com page
      dataHook: 'login',
      href: createSigningPageUrl({ config: globalConfig, isMobile }),
    };
  }
  if (type === SigningButtonType.GetStarted) {
    return {
      biName: 'get_started',
      translationKey: 'menu_get_started',
      classNames: [s.primaryButton, s.signUpButton],
      dataHook: 'get-started-button',
      href: createSigningPageUrl({ config: globalConfig, isMobile, signingType: 'SignUp' }),
    };
  }
  return {
    biName: 'log_in',
    translationKey: 'menu_log_in',
    classNames: [s.secondaryButton],
    dataHook: 'log-in-button',
    href: createSigningPageUrl({ config: globalConfig, isMobile, signingType: 'LogIn' }),
  };
};
